import { formatMessage } from "@app/translations/intl";

export const SEARCH_QUERY_PARAM = "q";

/** `?q=apple%20air` (or `?q=apple+air`) -> `apple air`. Empty string when the param is absent. */
export const getSearchQueryFromSearch = (search?: string): string =>
  new URLSearchParams(search || "").get(SEARCH_QUERY_PARAM) || "";

/** `apple air` -> `?q=apple%20air`, so the value survives a reload and a copy-pasted URL. */
export const searchQueryString = (searchQuery: string): string =>
  `?${SEARCH_QUERY_PARAM}=${encodeURIComponent(searchQuery)}`;

const searchPageLink = (searchQuery?: string) => {
  const rootUrl = formatMessage({ id: "global.searchPage.url" });

  if (!searchQuery) {
    return rootUrl;
  }

  return `${rootUrl.endsWith("/") ? rootUrl.slice(0, -1) : rootUrl}${searchQueryString(searchQuery)}`;
};

export { searchPageLink };
